import { Injectable } from '@angular/core';
import { ConstsHelper } from '../../helpers/consts.helper';
import { select, Store } from '@ngrx/store';
import { GetAlertMessage } from './store/actions/alert-message.actions';
import { AlertMessageInterface } from './models/alert-message.interface';
import { Action } from '@ngrx/store';
import { RefreshToken } from '../authentication/store/actions/refresh-token.actions';
import { RefreshTokenState } from '../authentication/store/state/refresh-token.state';
import moment from 'moment';
import {GetLine} from '../lines/store/actions/line.actions';
import {environment} from '../../../environments/environment';

@Injectable()
export class AbstractEffects {

    constructor(public store: Store<any>) {}

    /**
     * @param action
     * @constructor
     */
    ResendRequestWithNewToken(action: Action) {
        // Get new token
        this.store.dispatch(new RefreshToken());
        // Wait for the new token
        this.store.pipe(select(ConstsHelper.REDUCER_REFRESH_TOKEN)).subscribe((response: RefreshTokenState) => {
            if (null != response.customerToken) {
                // Dispatch the event or resend same request with the new token
                this.store.dispatch(action);
            }
        });
    }

    /**
     * @param procedureCode
     * @param code
     * @param object
     */
    getMessage(procedureCode: string, code: number, object?: any) {
        if (code === 200) {
            const messages = new Map();
            /******************************************* MSISDN *******************************************/
            messages.set(ConstsHelper.PROCEDURE_BILL_PROTEST, ConstsHelper.CONFIRMATION_MESSAGE_BILL_PROTEST);
            messages.set(ConstsHelper.PROCEDURE_IDENTIFY_LINE, ConstsHelper.CONFIRMATION_MESSAGE_IDENTIFY_LINE);
            messages.set(ConstsHelper.PROCEDURE_NOT_RECEIVED_CARD, ConstsHelper.CONFIRMATION_MESSAGE_NOT_RECEIVED_SIM_CARD);
            messages.set(ConstsHelper.PROCEDURE_RECHARGE_DATA, ConstsHelper.CONFIRMATION_MESSAGE_RECHARGE_DATA);
            messages.set(ConstsHelper.PROCEDURE_RECHARGE_VOICE, ConstsHelper.CONFIRMATION_MESSAGE_RECHARGE_VOICE);
            messages.set(ConstsHelper.PROCEDURE_CANCEL_SIM_ORDER, ConstsHelper.CONFIRMATION_MESSAGE_CANCEL_SIM_ORDER);
            messages.set(ConstsHelper.PROCEDURE_CANCEL_LOSS_STEAL, ConstsHelper.CONFIRMATION_MESSAGE_CANCEL_LOSS_STEAL);

            /******************************************* BILLS *******************************************/
            messages.set(ConstsHelper.PROCEDURE_BILL_PROTEST, ConstsHelper.CONFIRMATION_MESSAGE_BILL_PROTEST);
            messages.set(ConstsHelper.PROCEDURE_BILL_DETAILS, ConstsHelper.CONFIRMATION_MESSAGE_BILL_DETAILS);

            /******************************************* CUSTOMER *******************************************/
            messages.set(ConstsHelper.PROCEDURE_DELIVERY_ADDRESS_CHANGE, ConstsHelper.CONFIRMATION_MESSAGE_UPDATE_CUSTOMER_DELIVERY_ADDRESS);
            messages.set(ConstsHelper.PROCEDURE_BILLING_ADDRESS_CHANGE, ConstsHelper.CONFIRMATION_MESSAGE_UPDATE_CUSTOMER_BILLING_ADDRESS);
            messages.set(ConstsHelper.PROCEDURE_CUSTOMER_INFORMATION_CHANGE, ConstsHelper.CONFIRMATION_MESSAGE_UPDATE_CUSTOMER);
            messages.set(ConstsHelper.PROCEDURE_CUSTOMER_PASSWORD_CHANGE, ConstsHelper.CONFIRMATION_MESSAGE_UPDATE_PASSWORD);
            messages.set(ConstsHelper.PROCEDURE_RESET_PASSWORD, ConstsHelper.CONFIRMATION_MESSAGE_UPDATE_PASSWORD);
            messages.set(ConstsHelper.PROCEDURE_CREDIT_MY_ACCOUNT, ConstsHelper.CONFIRMATION_MESSAGE_CREDIT_ACCOUNT);
            messages.set(ConstsHelper.PROCEDURE_EXPRESS_PAYMENT, ConstsHelper.CONFIRMATION_MESSAGE_BILL_PAYMENT);
            messages.set(ConstsHelper.PROCEDURE_UNBLOCK_LINE, ConstsHelper.CONFIRMATION_MESSAGE_UNBLOCK_LINE);
            messages.set(ConstsHelper.PROCEDURE_GENERATE_SEPA_MANDATE, ConstsHelper.CONFIRMATION_MESSAGE_GENERATE_SEPA_MANDATE);
            messages.set(ConstsHelper.PROCEDURE_UPDATE_IBAN, ConstsHelper.CONFIRMATION_MESSAGE_UPDATE_IBAN);
            messages.set(ConstsHelper.PROCEDURE_CHANGE_FINAL_BILLING_DATE, ConstsHelper.CONFIRMATION_MESSAGE_CHANGE_FINAL_BILLING_DATE);

            if (messages.get(procedureCode)) {
                return messages.get(procedureCode);
            } else if (ConstsHelper.PROCEDURE_TERMINATE_LINE === procedureCode && object !== null) {
                this.store.dispatch(new GetLine(object.phoneNumber));
                const date = object.date.split('-');
                if (date.length === 3) {
                    return ConstsHelper.CONFIRMATION_MESSAGE_TERMINATE_LINE[0] + object.phoneNumber + ConstsHelper.CONFIRMATION_MESSAGE_TERMINATE_LINE[1] + date[2] + '/' + date[1] + '/' + date[0];
                } else {
                    return ConstsHelper.CONFIRMATION_MESSAGE_TERMINATE_LINE[2];
                }
            } else if (ConstsHelper.PROCEDURE_BLOCKING_MULTIMEDIA_PURCHASE === procedureCode && object !== null) {
                return object.active === false ? ConstsHelper.CONFIRMATION_MESSAGE_BLOCKING_MULTIMEDIA_PURCHASE : ConstsHelper.CONFIRMATION_MESSAGE_UNBLOCKING_MULTIMEDIA_PURCHASE;
            } else if (ConstsHelper.PROCEDURE_LOSS_STEAL === procedureCode && object !== null) {
                if (object.routeValue === 'ec_request' || object.routeValue === 'confirm_loss') {
                    return  object.simType === 4 ? ConstsHelper.CONFIRMATION_MESSAGE_LOSS_STEAL : ConstsHelper.CONFIRMATION_MESSAGE_LOSS_STEAL_ESIM;
                } else {
                    return ConstsHelper.CONFIRMATION_MESSAGE_CANCEL_LOSS_STEAL;
                }
            } else if (ConstsHelper.PROCEDURE_SURTAX_NUMBER === procedureCode && object !== null) {
                return object.active === false ? ConstsHelper.CONFIRMATION_MESSAGE_BLOCKING_SURTAX_NUMBERS : ConstsHelper.CONFIRMATION_MESSAGE_UNBLOCKING_SURTAX_NUMBERS;
            } else if (ConstsHelper.PROCEDURE_TOGGLE_SMS_INTERNET_PLUS === procedureCode && object !== null) {
                return object.active === false ? ConstsHelper.CONFIRMATION_MESSAGE_BLOCKING_TOGGLE_SMS_INTERNET_PLUS : ConstsHelper.CONFIRMATION_MESSAGE_UNBLOCKING_TOGGLE_SMS_INTERNET_PLUS;
            } else if (ConstsHelper.PROCEDURE_ACTIVATE_SIM_CARD === procedureCode && object !== null) {
                return object.isEsim === false ? ConstsHelper.CONFIRMATION_MESSAGE_SIM_CARD_ACTIVATION : ConstsHelper.CONFIRMATION_MESSAGE_ESIM_CARD_ACTIVATION;
            } else if (ConstsHelper.PROCEDURE_ORDER_SIM_CARD === procedureCode && object !== null) {
                return object.simType === 4 ? ConstsHelper.CONFIRMATION_MESSAGE_ORDER_SIM_CARD : ConstsHelper.CONFIRMATION_MESSAGE_ORDER_ESIM_CARD;
            } else if (ConstsHelper.PROCEDURE_VISUAL_MESSAGING === procedureCode && object !== null) {
                return object.active === false ? ConstsHelper.CONFIRMATION_MESSAGE_VISUAL_MESSAGING_DEACTIVATION : ConstsHelper.CONFIRMATION_MESSAGE_VISUAL_MESSAGING_ACTIVATION;
            } else if (ConstsHelper.PROCEDURE_ACTIVATION_5G === procedureCode && object !== null) {
                return object.active === true ? ConstsHelper.CONFIRMATION_MESSAGE_5G_ACTIVATION : ConstsHelper.CONFIRMATION_MESSAGE_5G_DEACTIVATION;
            } else if (ConstsHelper.PROCEDURE_CONTACTS === procedureCode && object !== null) {
                return object.active === true ? ConstsHelper.CONFIRMATION_MESSAGE_200_CONTACTS_ACTIVATION : ConstsHelper.CONFIRMATION_MESSAGE_200_CONTACTS_DEACTIVATION;
            } else if (ConstsHelper.PROCEDURE_THREE_WAY_CONFERENCE === procedureCode && object !== null) {
                return object.active === true ? ConstsHelper.CONFIRMATION_MESSAGE_THREE_WAY_CONFERENCE_ACTIVATION : ConstsHelper.CONFIRMATION_MESSAGE_THREE_WAY_CONFERENCE_DEACTIVATION;
            } else if (ConstsHelper.PROCEDURE_CHANGE_OFFER === procedureCode && object !== null) {
                if (object.currentNetwork === 'orange') {
                    return 'Vous bénéficierez du forfait ' + object.offerName + ' à compter du mois ' + object.notificationMonth;
                } else {
                    const changeOfferMessage = 'Vous bénéficiez désormais du forfait ' + object.offerName + '. Un délai de 24h peut être nécessaire pour que tous les services soient fonctionnels.';
                    return object.typeChange === 'next_month' ? 'Vous bénéficierez du forfait ' + object.offerName + ' au début du mois prochain.' : changeOfferMessage;
                }
            } else if (ConstsHelper.PROCEDURE_CANCEL_CHANGE_OFFER === procedureCode && object !== null) {
                if (object.portabilityDate !== null) {
                    if (object.differenceInDays <= 3) {
                        return ConstsHelper.CONFIRMATION_MESSAGE_CANCEL_CHANGE_OFFER[1];
                    } else {
                        return ConstsHelper.CONFIRMATION_MESSAGE_CANCEL_CHANGE_OFFER[2];
                    }
                } else {
                    return ConstsHelper.CONFIRMATION_MESSAGE_CANCEL_CHANGE_OFFER[0];
                }
            } else if (ConstsHelper.PROCEDURE_CANCEL_TERMINATE_LINE === procedureCode && object !== null) {
                return ConstsHelper.CONFIRMATION_MESSAGE_CANCEL_TERMINATE_LINE[0]
                    +
                    object.phoneNumber
                    + ConstsHelper.CONFIRMATION_MESSAGE_CANCEL_TERMINATE_LINE[1]
                    + moment(new Date(object.endBillDate), 'YYYY-MM-DD').format('DD/MM/YYYY')
                    + ConstsHelper.CONFIRMATION_MESSAGE_CANCEL_TERMINATE_LINE[2];
            } else if (ConstsHelper.PROCEDURE_CHANGE_NETWORK === procedureCode && object !== null) {
                return ConstsHelper.CONFIRMATION_MESSAGE_CHANGE_NETWORK
                    + moment(new Date(object.portabilityDate), 'YYYY-MM-DD').format('DD/MM/YYYY')
                    + '.';
            } else if (ConstsHelper.PROCEDURE_ACCOUNT_CONSOLIDATION === procedureCode && object !== null) {
                if (object.response === null) {
                    return ConstsHelper.CONFIRMATION_MESSAGE_ACCOUNT_CONSOLIDATION[0]
                        + object.destinationAccount
                        + ConstsHelper.CONFIRMATION_MESSAGE_ACCOUNT_CONSOLIDATION[1];
                } else {
                    if (object.response === true) {
                        return ConstsHelper.CONFIRMATION_MESSAGE_ACCOUNT_CONSOLIDATION[2]
                            + object.customerId
                            + ConstsHelper.CONFIRMATION_MESSAGE_ACCOUNT_CONSOLIDATION[3]
                            + object.externalId
                            + ConstsHelper.CONFIRMATION_MESSAGE_ACCOUNT_CONSOLIDATION[4];
                    } else {
                        return ConstsHelper.CONFIRMATION_MESSAGE_ACCOUNT_CONSOLIDATION[5]
                            + object.customerId
                            + ConstsHelper.CONFIRMATION_MESSAGE_ACCOUNT_CONSOLIDATION[6]
                            + object.externalId
                            + ConstsHelper.CONFIRMATION_MESSAGE_ACCOUNT_CONSOLIDATION[7];

                    }
                }
            } else if (ConstsHelper.PROCEDURE_PAYMENT_METHOD_CHANGE === procedureCode && object !== null) {
                switch (object.routeValue) {
                    case 'delete_cb':
                        return ConstsHelper.CONFIRMATION_MESSAGE_DELETE_CB;
                    case 'delete_iban':
                        return ConstsHelper.CONFIRMATION_MESSAGE_DELETE_IBAN;
                    case 'cb_pay_method_change':
                        return ConstsHelper.CONFIRMATION_MESSAGE_SAVE_PAYMENT_CARD;
                    case 'cb_pay_method':
                        return ConstsHelper.CONFIRMATION_MESSAGE_CHANGE_PAYMENT_METHOD_TO_CARD;
                    case 'debit_pay_method':
                        if (object.message) {
                            return ConstsHelper.CONFIRMATION_MESSAGE_SAVE_RIB;
                        } else {
                            return ConstsHelper.CONFIRMATION_MESSAGE_CHANGE_PAYMENT_METHOD_TO_RIB;
                        }
                }
            } else if (ConstsHelper.PROCEDURE_NOT_RECEIVED_CARD === procedureCode) {
                return ConstsHelper.CONFIRMATION_MESSAGE_NOT_RECEIVED_SIM_CARD;
            } else if (ConstsHelper.PROCEDURE_TECHNICAL_ASSISTANCE === procedureCode) {

                setTimeout( () => {
                    window.open(environment.data.assistanceUrl, '_blank');
                }, 500);

                return ConstsHelper.CONFIRMATION_MESSAGE_TECHNICAL_ASSISTANCE;

            }

            return ConstsHelper.CONFIRMATION_MESSAGE_MISSION;
        }
        if (code === 300) {
            if (procedureCode === 'in_progress_procedure') {
                return ConstsHelper.IN_PROGRESS_MESSAGE_MISSION;
            }
            return ConstsHelper.ERROR_OCCURRED_RETRY_MESSAGE;
        }
        if (code === 400) {
            switch (procedureCode) {
                case 'error_download_bill':
                    return ConstsHelper.ERROR_MESSAGE_DOWNLOAD_BILL;
                case 'error_download_file':
                    return ConstsHelper.ERROR_MESSAGE_DOWNLOAD_FILE;
                case ConstsHelper.PROCEDURE_BILL_DETAILS:
                    return ConstsHelper.IN_PROGRESS_MESSAGE_BILL_DETAILS;
                case 'error_with_retry':
                    return ConstsHelper.ERROR_OCCURRED_RETRY_MESSAGE;
                case 'error_authentication':
                    return ConstsHelper.ERROR_MESSAGE_AUTHENTICATION;
                case 'email_already_used':
                    return ConstsHelper.ERROR_MESSAGE_EMAIL_ALREADY_USED;
                case 'error_to_generate_esim':
                    return ConstsHelper.ERROR_MESSAGE_GENERATE_ESIM;
            }
            return ConstsHelper.ERROR_OCCURRED_MESSAGE;
        }
    }

    /**
     * @param procedureCode
     * @param code
     * @param action
     * @param object
     * @constructor
     */
    DisplayMessage(procedureCode: string, code: number, action?: Action, object?: any) {
        // Display error message
        const alertMessage = { message: this.getMessage(procedureCode, code, object) , code} as AlertMessageInterface;
        this.store.dispatch(new GetAlertMessage(alertMessage));
        // Dispatch failure action
        if (action) {
            this.store.dispatch(action);
        }
    }
}
